import React from 'react';
import classnames from 'classnames';
import LinesEllipsis from 'react-lines-ellipsis';
import { Link } from '@latitude/link';
import Image from '@latitude/image';
import CardTitle from '../CardTitle/CardTitle';
import './_media.scss';

const component = 'media-featured';

const MediaFeatured = props => {
  const {
    date,
    description,
    buttonProps,
    maxLines,
    className,
    imageProps,
    titleProps,
    style
  } = props;

  return (
    <article className={classnames(`${component}`, className)} style={style}>
      <div className="media-featured-item">
        <div className={`${component}__image`}>
          <Image {...imageProps} imageOnly />
        </div>
        <div className={`${component}__content`}>
          <CardTitle {...titleProps} />
          <strong className={`${component}__date`}>{date}</strong>
          <div className={`${component}__text`}>
            <LinesEllipsis
              text={description}
              maxLine={maxLines || '5'}
              ellipsis="..."
              trimRight
              basedOn="words"
            />
          </div>
          <div className={`${component}__button`}>
            {buttonProps && (
              <Link
                trackEventData={{
                  location: titleProps.title
                }}
                {...buttonProps}
              >
                {buttonProps.btnText}
              </Link>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

export default MediaFeatured;
